/**
 * Recettes de démonstration et de secours (Assistant Vide-Frigo)
 */

const DEMO_IMAGES = {
  omelette: "https://www.themealdb.com/images/media/meals/1543775015.jpg",
  pasta: "https://www.themealdb.com/images/media/meals/ustsqw1468250014.jpg",
  chicken: "https://www.themealdb.com/images/media/meals/1520081754.jpg",
  caesar: "https://www.themealdb.com/images/media/meals/ursuup1487348423.jpg",
  rice: "https://www.themealdb.com/images/media/meals/1520082644.jpg",
};

export function getDemoRecipes(availableIngredients) {
  const n = availableIngredients.length;
  return [
    {
      id: "demo-1",
      title: "Omelette aux Herbes 🍳",
      description: "Parfait pour le petit-déjeuner",
      ingredients: "3 Œufs\nSel\nPoivre\nBeurre\nCiboulette",
      difficulty: "Facile",
      matchPercentage: 80,
      matchCount: Math.min(4, n),
      totalIngredients: 5,
      foundIngredients: availableIngredients.slice(0, 4),
      missingIngredients: ["Beurre"],
      source: "Démo",
      image: DEMO_IMAGES.omelette,
    },
    {
      id: "demo-2",
      title: "Pâtes à la Tomate 🍝",
      description: "Classique italien facile",
      ingredients: "Pâtes\nTomates\nAil\nHuile d'olive\nBasilic",
      difficulty: "Facile",
      matchPercentage: 75,
      matchCount: Math.min(3, n),
      totalIngredients: 5,
      foundIngredients: availableIngredients.slice(0, 3),
      missingIngredients: ["Pâtes", "Basilic"],
      source: "Démo",
      image: DEMO_IMAGES.pasta,
    },
    {
      id: "demo-3",
      title: "Poulet Grillé 🍗",
      description: "Plat principal savoureux",
      ingredients: "Poulet\nSel\nPoivre\nHuile\nCitron",
      difficulty: "Moyen",
      matchPercentage: 60,
      matchCount: Math.min(2, n),
      totalIngredients: 5,
      foundIngredients: availableIngredients.slice(0, 2),
      missingIngredients: ["Poulet", "Citron"],
      source: "Démo",
      image: DEMO_IMAGES.chicken,
    },
    {
      id: "demo-4",
      title: "Salade César 🥗",
      description: "Entrée fraîche et croquante",
      ingredients: "Laitue\nPoulet\nParmesan\nCroûtons\nSauce César",
      difficulty: "Facile",
      matchPercentage: 70,
      matchCount: Math.min(3, n),
      totalIngredients: 5,
      foundIngredients: availableIngredients.slice(0, 3),
      missingIngredients: ["Parmesan", "Croûtons"],
      source: "Démo",
      image: DEMO_IMAGES.caesar,
    },
    {
      id: "demo-5",
      title: "Riz Sauté aux Légumes 🍚",
      description: "Repas complet asiatique",
      ingredients: "Riz\nŒufs\nLégumes\nSauce soja\nOignon",
      difficulty: "Moyen",
      matchPercentage: 65,
      matchCount: Math.min(3, n),
      totalIngredients: 5,
      foundIngredients: availableIngredients.slice(0, 3),
      missingIngredients: ["Riz", "Sauce soja"],
      source: "Démo",
      image: DEMO_IMAGES.rice,
    },
  ];
}

export function getEmergencyRecipe(availableIngredients) {
  return {
    id: "emergency-1",
    title: "Recette Rapide ⚡",
    description: "Toujours disponible",
    ingredients: availableIngredients.join("\n") || "Ingrédients de base",
    difficulty: "Facile",
    matchPercentage: 100,
    matchCount: availableIngredients.length,
    totalIngredients: availableIngredients.length,
    foundIngredients: availableIngredients,
    missingIngredients: [],
    source: "Secours",
  };
}
